export const dictionary = [
    {
        key: 'required',
        dict: {
            en: 'The field is required',
            lt: 'Negali būti tuščia'
        }
    },
    {
        key: 'email',
        dict: {
            en: 'Email has invalid format',
            lt: 'Įveskite teisingą elektroninio pašto adresą'
        }
    },
    {
        key: 'maxLength',
        dict: {
            en: 'The field must contain a maximum of :value characters',
            lt: 'Įveskite ne daugiau kaip :value simbolių'
        }
    },
    {
        key: 'minLength',
        dict: {
            en: 'The field must contain a minimum of :value characters',
            lt: 'Įveskite bent :value simbolius'
        }
    },
    {
        key: 'password',
        dict: {
            en: 'Password must contain minimum eight characters, at least one letter and one number',
            lt: 'Slaptažodį privalo sudaryti ne mažiau nei 8 simboliai, bent viena raidė ir vienas skaičius'
        }
    },
    {
        key: 'strongPassword',
        dict: {
            en: 'Password should contain minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character',
            lt: 'Slaptažodį privalo sudaryti ne mažiau nei 8 simboliai, bent vienas skaičius, didžioji ir mažoji raidės ir specialus simbolis'
        }
    },
    {
        key: 'customRegexp',
        dict: {
            en: 'Field value does not comply with the rules',
            lt: 'Lauko reikšmė neatitinka taisyklių'
        }
    },
    {
        key: 'number',
        dict: {
            en: 'Use digits only',
            lt: 'Naudokite tik skaitmenis'
        }
    },
    {
        key: 'integer',
        dict: {
            en: 'Enter an integer',
            lt: 'Įveskite svekąjį skaičių'
        }
    },
    {
        key: 'maxNumber',
        dict: {
            en: 'Number should be less or equal than :value',
            lt: 'Įveskite reikšmę mažesnę arba lygią :value'
        }
    },
    {
        key: 'minNumber',
        dict: {
            en: 'Number should be more or equal than :value',
            lt: 'Įveskite reikšmę didesnę arba lygią :value'
        }
    },
    {
        key: 'minFilesCount',
        dict: {
            en: 'The field is required',
            lt: 'Negali būti tuščia'
        }
    },
    {
        key: 'maxFilesCount',
        dict: {
            en: 'Files count should be less or equal than :value',
            lt: 'Failų skaičius turi būti mažesnis arba lygus :value'
        }
    },
    {
        key: 'checkboxGroup',
        dict: {
            en: 'At least one checkbox must be selected.',
            lt: 'Būtina pažymėti bent vieną žymimąjį langelį.'
        }
    },
];
